import useKeyWithInterval from '~/hooks/common/ui/useKeyWithInterval';
import { useVehiclePrice } from '~/hooks/vdp/useVehiclePrice';
import formatAndDropDecimal from '~/utilities/formatAndDropDecimal';
import { OriginalPrice, PriceWrapper, StyledPrice } from './Price.styles';

export default function NewVehiclePrice() {
  const priceKey = useKeyWithInterval();
  const { finalPrice, originalPrice } = useVehiclePrice();

  return (
    <PriceWrapper>
      <StyledPrice key={priceKey}>
        ${formatAndDropDecimal(finalPrice)}
      </StyledPrice>
      <OriginalPrice>
        MSRP{' '}
        <span className="line-through">
          ${formatAndDropDecimal(originalPrice)}
        </span>
      </OriginalPrice>
    </PriceWrapper>
  );
}
